import {useEffect, useState} from 'react';
import {getBankAccounts} from "../../api/Api";
import {Select} from "antd";

export const BankSelectWidget = ({style, accountId, setAccountId, onApiFail, altText, props}) => {
    const [bankOptions, setBankOptions] = useState([]);

    useEffect(() => {
        getBankAccounts().then(result => {
            setBankOptions(result.map(r => {
                return {
                    key: r.id,
                    value: r.id,
                    label: r.name,
                    account: r
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail])


    const onBankChange = (val, option) => {
        if (setAccountId) {
            setAccountId(val);
        }
    }

    const alternate = altText ? altText : 'account';

    return <div>
        <Select style={{...style}} value={accountId} placeholder={alternate} options={bankOptions} onChange={onBankChange} popupMatchSelectWidth={false}/>
    </div>
}